import { getLayoutKeyForMetaObjects } from '../../../utils/getLayoutKeyForMetaObjects';
import { ppData } from '../../../configs/ppData.config';
export const getCornerImg = (layout, frameStyle, frameColor) => {
    const imgObj = ppData.cornerImages?.[getLayoutKeyForMetaObjects(layout)];
    if (!ppData.isTiles && layout.includes('framed')) {
        return imgObj?.[frameStyle ?? '']?.[frameColor ?? ''];
    }
    return imgObj?.default;
};
